import React from "react";
import { createPortal } from "react-dom";
import { useToast } from "./ToastContext.tsx";
import { ToastItem } from "./ToastItem.tsx";
import type { ToastPosition } from "./types.ts";

function getPositionStyle(position: ToastPosition): React.CSSProperties {
  const base: React.CSSProperties = {
    position: "fixed",
    zIndex: 99999,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    padding: 16,
    pointerEvents: "none",
  };

  switch (position) {
    case "top-right":
      return { ...base, top: 0, right: 0, alignItems: "flex-end" };
    case "top-left":
      return { ...base, top: 0, left: 0, alignItems: "flex-start" };
    case "top-center":
      return { ...base, top: 0, left: "50%", transform: "translateX(-50%)", alignItems: "center" };
    case "bottom-right":
      return { ...base, bottom: 0, right: 0, alignItems: "flex-end", flexDirection: "column-reverse" };
    case "bottom-left":
      return { ...base, bottom: 0, left: 0, alignItems: "flex-start", flexDirection: "column-reverse" };
    case "bottom-center":
      return { ...base, bottom: 0, left: "50%", transform: "translateX(-50%)", alignItems: "center", flexDirection: "column-reverse" };
  }
}

interface ToastContainerProps {
  position?: ToastPosition;
}

export function ToastContainer({ position = "top-right" }: ToastContainerProps) {
  const { toasts, dismiss } = useToast();

  return createPortal(
    <div aria-label="Notifications" role="region" style={getPositionStyle(position)}>
      {toasts.map((toast, index) => (
        <div key={toast.id} style={{ pointerEvents: "auto" }}>
          <ToastItem toast={toast} onDismiss={dismiss} index={index} />
        </div>
      ))}
    </div>,
    document.body
  );
}
